<template>
    <div class="animated fadeIn">
        <basic-heading title="Quality Control">
            <template #right-content>
                <header-button-group :button_config="button_config"></header-button-group>
            </template>
        </basic-heading>
        <quality-control-table></quality-control-table>
    </div>
</template>
<script>
import BasicHeading from '@/components/shared/BasicHeading.vue';
import QualityControlTable from '@/components/lab/qualitycontrol/QualityControlTable.vue';
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import { AccessControlCheck } from '@/auth/AccessControlCheck';

export default {
    name: "ResultExportIndex",
    components: {
        BasicHeading,
        QualityControlTable,
        HeaderButtonGroup
    },
    data() {
        return {
            button_config: {
                buttons: [
                    {
                        icon: "fa-plus",
                        linkto: "/quality-control/add",
                        title: "Add Quality Control",
                        variant: "success",
                        permission: this.checkPermission("add quality control")
                    },
                ],
            },
        };
    },
    methods: {
        checkPermission(permission) {
            return AccessControlCheck.checkPermission(permission);
        }
    }
}
</script>